import { get } from '../../utils';
import { getTermFromState } from '../../redux/selectors/i18n';

/**
 * Check to see if the user has a valid zip code.
 * @param state - The Redux store
 * @returns {boolean}
 */
const userHasKnownValidZipCode = (state) => {
  const zipCode = get(state, 'dma.zipCode');
  return !!(zipCode);
};

/**
 * If the user has not entered a valid zip code the zip modal will
 * prevent them from proceeding any further. All calls past the
 * Vehicle grd require a valid Zip Code
 * @param state - The Redux store
 * @returns {boolean}
 */
export const shouldShowZipModal = (state) => {
  const isUserChangingLocation = state.dma.userChangingLocation === true;
  const userHasValidZipCode = userHasKnownValidZipCode(state);
  const show = (isUserChangingLocation === true) || userHasValidZipCode === false;
  return show;
};

/**
 * Returns the Location name for displaying in the User Amounts Panel.
 * @param state - The Redux store
 * @returns {string}
 */
export const getLocationName = (state) => {
  const dma = state.dma;
  if (!dma.dmaCityName || !dma.dmaStateCode) {
    return getTermFromState(state, 'personalizePanel.locationLabelDefault')
  }
  return `${dma.dmaCityName}, ${dma.dmaStateCode}`
};

export const getCurrentZipCode = (state) => {
  const dma = state.dma;
  return dma.zipCode ? dma.zipCode : false;
}



/** WEBPACK FOOTER **
 ** ./src/redux/selectors/dma.js
 **/